// const service = 'http://sosoapi.yunqueyi.com/sosoapi-web/pass/mock/46';
const service = '/healths';
const messageApi = {
  getMessage: service + '/sendLogs/yunqueyilian',
}

export default messageApi



// WEBPACK FOOTER //
// ./src/apis/services/message.js